import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<
  void,
  'menu' | 'author' | 'quote' | 'activeMenu'
>()(({ tokens }, _, classes) => ({
  quote: {
    padding: '16px',
    backgroundColor: tokens.colors.bg.greyscale.primary,
    border: '1px solid',
    borderLeft: '8px solid',
    borderColor: tokens.colors.original.brand.quaternary,
    borderRadius: tokens.radius.s,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    position: 'relative',
    [`&:hover .${classes.menu}`]: {
      opacity: 1,
      visibility: 'visible',
    },
  },
  author: {
    fontStyle: 'italic',
  },
  menu: {
    visibility: 'hidden',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    opacity: 0,
    transition: 'opacity 0.15s ease-in-out, visibility 0.15s ease-in-out',
  },
  activeMenu: {
    opacity: 1,
    visibility: 'visible',
  },
}));
